export const resetRangeDefaults = observable => {
  if (observable.plateAxis === "X") {
    observable.lowZRange = observable.defaults["lowZRange"];
    observable.highZRange = observable.defaults["highZRange"];
    observable.lowXRange = observable.defaults["lowXRange"];
    observable.highXRange = observable.defaults["highXRange"];
    observable.lowBucketRange = observable.defaults["lowBucketRange"];
    observable.highBucketRange = observable.defaults["highBucketRange"];
  } else {
    observable.lowZRange = "1.2";
    observable.highZRange = "3.7";
    observable.lowXRange = "-0.5";
    observable.highXRange = "0.5";
    observable.lowBucketRange = "1.2";
    observable.highBucketRange = "3.7";
  }
};



// WEBPACK FOOTER //
// ./src/utils/defaults.js